/**
 * Creates a type guard function for a specific type in a union type
 * @param typename The __typename to check for
 * @returns A type guard function that checks if an object has the specified __typename
 */
export function createTypeGuard<T extends { __typename?: string }>(typename: string) {
  return (obj: { __typename?: string } | null | undefined): obj is T => {
    return obj?.__typename === typename;
  };
}

/**
 * Helper function to safely access properties of a union type
 * @param obj The object to check
 * @param typename The __typename to check for
 * @param callback Function to execute if the type matches
 * @returns The result of the callback if the type matches, otherwise undefined
 */
export function withType<T extends { __typename?: string }>(
  obj: { __typename?: string } | null | undefined,
  typename: string,
  callback: (obj: T) => React.ReactNode,
): React.ReactNode {
  if (obj?.__typename === typename) {
    return callback(obj as T);
  }
  return null;
}
